import Vue from 'vue'
import rest from '@/core/rest'

let userItems = {}
let workspaceItems = {}

function safeJsonParse (value) {
  if (!value || typeof value !== 'string') {
    return {}
  }
  try {
    const parsed = JSON.parse(value)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    return {}
  }
}

const ServerCache = {
  init (data) {
    userItems = safeJsonParse(data?.userCache?.cache)
    workspaceItems = safeJsonParse(data?.workspaceCache?.cache)
  },

  clear () {
    userItems = {}
    workspaceItems = {}
  },

  async get (key, scope = 'user') {
    if (scope === 'user') {
      return key ? userItems[key] : userItems
    }
    if (scope === 'workspace') {
      return key ? workspaceItems[key] : workspaceItems
    }
    return null
  },

  async set (key, value, scope = 'user') {
    if (scope === 'user') {
      userItems[key] = value
      this.storeUserCache(userItems)
      return
    }
    if (scope === 'workspace') {
      workspaceItems[key] = value
      this.storeWorkspaceCache(workspaceItems)
    }
  },

  storeUserCache (pdata) {
    rest.put('user/cache/user', { cache: JSON.stringify(pdata) }, () => {})
  },

  storeWorkspaceCache (pdata) {
    rest.put('user/cache/workspace', { cache: JSON.stringify(pdata) }, () => {})
  },

  save (pdata, cb = () => {}, scope = 'user') {
    rest.put('user/cache/' + scope, { cache: JSON.stringify(pdata) }, cb)
  }
}

ServerCache.install = function () {
  Object.defineProperty(Vue.prototype, '$serverCache', {
    get () { return ServerCache }
  })
}

export default ServerCache
